import script from "./verify-email.vue?vue&type=script&setup=true&lang=js"
export * from "./verify-email.vue?vue&type=script&setup=true&lang=js"

import "./verify-email.vue?vue&type=style&index=0&id=4c183748&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c183748"]])

export default __exports__